import { Card, CardContent } from '../../../card';
import LoadingSpinner from '../../../loading-spinner';

export const ImprovementLoadingResults = () => {
  return (
    <Card className="border-[#00000014] bg-prompt-safecomwhite shadow-sm">
      <CardContent className="flex flex-col items-center justify-center gap-3 px-6 py-12 text-center">
        <LoadingSpinner size={40} strokeWidth={4} />
        <p className="text-base font-semibold text-prompt-safecomvulcan">
          Analysing evaluation results...
        </p>
        <p className="text-sm text-prompt-safecomabbey">
          Identifying patterns and generating suggestions
        </p>
      </CardContent>
    </Card>
  );
};
